module.exports = __webpack_public_path__ + "img/4.55395ae0.jpg";